import { Button } from "@mui/material";



export function DownloadCsvButton({ arrayOfObjectsData, filename, buttonText }) {

    const headers = arrayOfObjectsData.length > 0 ? Object.keys(arrayOfObjectsData[0]) : [];
    const csvRows = [
        headers.join(","),
        ...arrayOfObjectsData.map(row => headers.map(header => JSON.stringify(row[header] ?? "")).join(","))
    ].join("\n");

    const handleDownload = () => {
        const blob = new Blob([csvRows], { type: "text/csv" });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    };

    return <Button color={"primary"} size="medium" variant="contained" onClick={handleDownload}>{buttonText}</Button>;
}